"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDfpNetworksComponent = void 0;
//ANGULAR 2 BITS
const core_1 = require("@angular/core");
const organization_1 = require("./organization");
//INTERNAL BITS
const lineitem_automation_service_1 = require("./lineitem-automation.service");
const user_service_1 = require("./user.service");
const notification_service_1 = require("./notification.service");
let UpdateDfpNetworksComponent = class UpdateDfpNetworksComponent {
    constructor(_lia, _user, _talk) {
        this._lia = _lia;
        this._user = _user;
        this._talk = _talk;
        this.hasUpdated = new core_1.EventEmitter();
        this.newDfpNetwork = { networkCode: null };
        this.invalidDfpNetworkCode = false;
        this.dfpVerification = { running: false, isInvalid: false };
        this.approvedNetworkCodes = [];
    }
    ngOnInit() {
        this.loadDfpNetworkCodes();
    }
    loadDfpNetworkCodes() {
        return this._lia.getDfpNetworks(this.organization.id)
            .then(savedCodes => {
            this.approvedNetworkCodes = (savedCodes && savedCodes.length > 0) ? savedCodes : [];
            return this.approvedNetworkCodes;
        })
            .catch(err => console.error('Unable to get saved codes', err));
    }
    onAddNewDfpNetworkCode() {
        if (this.newDfpNetwork.networkCode && !this.invalidDfpNetworkCode && !this.dfpVerification.running && !this.dfpVerification.isInvalid) {
            let newCode = this.newDfpNetwork.networkCode;
            if (this.exists(newCode))
                return this._talk.broadcast(`<h2>Network Code(${newCode}) is already added</h2>`);
            this._lia.addDfpNetwork({
                networkCode: parseInt(this.newDfpNetwork.networkCode),
                organization: this.organization.id,
                displayName: this.newDfpNetwork.displayName || null
            })
                .then(added => {
                if (added) {
                    this.approvedNetworkCodes.unshift({
                        networkCode: added.networkCode,
                        displayName: added.displayName,
                        organization: added.organization,
                        id: added.id
                    });
                    this.clearFormInput();
                    this.hasUpdated.emit(this.approvedNetworkCodes);
                }
            })
                .catch(err => { this._talk.broadcast('Oops! We had an internal problem adding this DFP Network Code.'); });
        }
    }
    deleteNetworkCode(network) {
        this._talk.confirm(`<h2>Are you sure you want to delete this Network Code(${network.networkCode})?</h2>`)
            .then(resultPromise => {
            if (resultPromise.result)
                return resultPromise.result
                    .then(result => {
                    if (result) {
                        return this._lia.deleteDfpNetwork(network.id)
                            .then(deleted => this.loadDfpNetworkCodes())
                            .then(done => {
                            this._talk.broadcast(`<h2>Network Code(${network.networkCode}) Successfully Deleted </h2>`);
                            this.hasUpdated.emit(this.approvedNetworkCodes);
                        })
                            .catch(err => { this._talk.broadcast(`<h2>Unable to delete Network Code(${network.networkCode})</h2>`); console.error(err); });
                    }
                });
        }).catch(err => { });
    }
    saveEditedNetworkChanges(network) {
        this._lia.updateDfpNetwork(network.id, { networkCode: network.networkCode, displayName: network.displayName })
            .then(updated => this.loadDfpNetworkCodes())
            .then(updated => {
            this._talk.broadcast(`<h2>Network Code(${network.networkCode}) Successfully Updated </h2>`);
            this.hasUpdated.emit(this.approvedNetworkCodes);
        })
            .catch(err => { this._talk.broadcast(`<h2>Unable to update Network Code(${network.networkCode})</h2>`); console.error(err); });
    }
    onFormInput() {
        if (!this.validateDfpNetworkCode() && this.newDfpNetwork.networkCode)
            this.startDfpVerification();
    }
    startDfpVerification() {
        this._lia.readDfpValues({
            bidder: null,
            commandName: 'validateNetworkId',
            dfpNetworkCode: parseInt(this.newDfpNetwork.networkCode),
            callOnEvent: { fn: this.onDfpVerificationEvent, context: this }
        });
        this.dfpVerification.running = true;
    }
    onDfpVerificationEvent(event) {
        switch (event.status) {
            case 'data':
                this.dfpVerification.running = false;
                this.dfpVerification.isInvalid = !event.data.valid;
                //Add the network display name for the new networkCode
                if (event.data.displayName)
                    this.newDfpNetwork.displayName = event.data.displayName;
                break;
            case 'error':
                this.dfpVerification.running = false;
                this._talk.broadcast(`<h2>We had a problem verifying this network Id</h2>`);
                break;
        }
    }
    exists(newCode) {
        if (this.approvedNetworkCodes) {
            return !!this.approvedNetworkCodes.find((code) => code.networkCode === newCode);
        }
        return false;
    }
    validateDfpNetworkCode() {
        //Should not contain non-digit characters
        this.invalidDfpNetworkCode = /\D/g.test(this.newDfpNetwork.networkCode);
        return this.invalidDfpNetworkCode;
    }
    clearFormInput() {
        this.newDfpNetwork.networkCode = null;
    }
};
exports.UpdateDfpNetworksComponent = UpdateDfpNetworksComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", organization_1.Organization)
], UpdateDfpNetworksComponent.prototype, "organization", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], UpdateDfpNetworksComponent.prototype, "hasUpdated", void 0);
exports.UpdateDfpNetworksComponent = UpdateDfpNetworksComponent = __decorate([
    (0, core_1.Component)({
        selector: 'update-dfp-networks',
        templateUrl: 'app/update-dfp-networks.component.html'
    }),
    __metadata("design:paramtypes", [lineitem_automation_service_1.LineAutomationService,
        user_service_1.UserService,
        notification_service_1.NotificationService])
], UpdateDfpNetworksComponent);
//# sourceMappingURL=update-dfp-networks.component.js.map